import { apiInstance, legacyV2Path, legacyV3Path } from '../index'
import { mapArgs } from 'corp-front-vue-commons/src/utils/functions'

const company = {
  get (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/company`,
      params
    })
  },

  getById (id) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/company/${id}`
    })
  },

  create (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV3Path()}/company/create`,
      data
    })
  },

  update (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV3Path()}/company/${id}`,
      data
    })
  },

  getConfig (id) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/company/${id}/config`
    })
  },

  getCompaniesFinancialConfig (ids) {
    const params = { companyIds: ids.toString() }
    return apiInstance({
      method: 'GET',
      url: `${legacyV3Path()}/company/financialConfig`,
      params
    })
  },

  getWalletFinancialConfig (id) {
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/financialAccount/${id}/financialConfig`
    })
  },

  getCompanyConfig (id) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/company/${id}/config`
    })
  },

  executeBulkOperation (companyId, bulkId, data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2Path()}/company/${companyId}/bulkoperation/${bulkId}/execute`,
      data
    })
  }
}

export default company
